import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/Transparent_Eulua_Logo-320.webp';
import FacebookIcon from '../../assets/images/Facebook_Icon.png';
import XIcon from '../../assets/images/X_Icon.png';
import InstagramIcon from '../../assets/images/Instagram_Icon.png';
import LinkedinIcon from '../../assets/images/Linkedin_Icon.png';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { useLocalizedPath } from '../../contexts/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { openCookieSettings } = useCookieConsent();
  // Spanish pages link to their Spanish counterparts directly, so crawlers see
  // /es -> /es links instead of English URLs fixed by a client-side redirect.
  const localized = useLocalizedPath();

  return (
    <footer className="footer">
      <div className="section">
        <h3 className="heading">Information</h3>
        <ul className="list">
          <li className="listItem"><Link to={localized('/about')} className="footerLink">About Us</Link></li>
          <li className="listItem"><Link to={`${localized('/')}#faqs`} className="footerLink">Frequently Asked Questions</Link></li>
          <li className="listItem"><Link to={localized('/shipping-policy')} className="footerLink">Shipping Policy</Link></li>
          <li className="listItem"><Link to={localized('/payment-methods')} className="footerLink">Payment Methods</Link></li>
          <li className="listItem"><Link to={localized('/privacy')} className="footerLink">Privacy Policy</Link></li>
          <li className="listItem"><Link to={localized('/cookies')} className="footerLink">Cookie Policy</Link></li>
          <li className="listItem"><button type="button" className="footerLink footerLinkButton" onClick={openCookieSettings}>Cookie Settings</button></li>
          <li className="listItem"><Link to={localized('/terms')} className="footerLink">Terms and Conditions</Link></li>
        </ul>
      </div>

      <div className="section">
        <h3 className="heading">We are here to help!</h3>
        <ul className="list">
          <li className="listItem"><Link to={localized('/account')} className="footerLink">My Account</Link></li>
          <li className="listItem"><Link to={localized('/orders')} className="footerLink">My Orders</Link></li>
          <li className="listItem"><Link to={localized('/sell')} className="footerLink">Join as a Seller</Link></li>
          <li className="listItem"><Link to={localized('/refunds')} className="footerLink">Returns and Refunds</Link></li>
          <li className="listItem"><Link to={localized('/developers')} className="footerLink">API Documentation</Link></li>
        </ul>
      </div>

      <div className="section">
        <div className="scheduleHeading">Service to the Client:</div>
        <div className="schedule">Monday - Friday: 7 AM - 6 PM</div>
        <div className="contactInfo">Email: <a className="footerLink" href="mailto:jm@eulua.com">jm@eulua.com</a></div>
      </div>

      <div className="section">
        <div className="logoContainer">
          <img src={Logo} alt="Eulua Logo" className="logo-image" />
        </div>
        <div className="socialIcons">
          <a href="https://facebook.com" className="socialLink">
            <img src={FacebookIcon} alt="Facebook" className="socialIconImage" />
          </a>
          <a href="https://x.com" className="socialLink">
            <img src={XIcon} alt="X" className="socialIconImage" />
          </a>
          <a href="https://instagram.com" className="socialLink">
            <img src={InstagramIcon} alt="Instagram" className="socialIconImage" />
          </a>
          <a href="https://linkedin.com" className="socialLink">
            <img src={LinkedinIcon} alt="LinkedIn" className="socialIconImage" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
